// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar_sidebar__1mzlz","top":"Sidebar_top__6B7Tb","middle":"Sidebar_middle__1PD46","bottom":"Sidebar_bottom__al_Xd"};